import Component from "../Component";
import ChartDataProvider from "./data/ChartDataProvider";

import "./ChartComponent.css";
import ChartDefault from "./channels/ChartDefault";

import Action from "./actions/Actions";
import "./ChartJsTooltipFix";
import ChartDrawObjectProvider from "./data/ChartDrawObjectProvider";
import Units from "../../utils/Units";


export default class ChartComponent extends Component {
    constructor(element) {
        super(element);

        this.element.classList.add("loading");

        /**create the canvas object*/
        this.canvas = document.createElement('canvas');
        this.element.appendChild(this.canvas);
        let ctx = this.canvas.getContext('2d');

        this.clickAction = Action.get(element.getAttribute("data-click"));
        this.hoverAction = Action.get(element.getAttribute("data-hover"));

        /**load data from provider*/
        this.load().then((data) => {
            if (null === data) {
                return;
            }
            if (data.datasets.length === 0) {
                //element.closest('.panel').style.display = 'none';
                //element.style.display = 'none';
                //return;
            }

            moment.defaultFormat = "YYYY-MM-DD HH:mm:ss";

            /**merge global config with config element*/
            let config = this.getDefaultConfig();
            if (element.getAttribute("data-config") && element.getAttribute("data-config") !== "") {
                config['options'] = Object.assign(config['options'], JSON.parse(element.getAttribute("data-config")));
            }

            if (element.getAttribute("data-draw-object") && element.getAttribute("data-draw-object") !== "") {
                var drawConfig = JSON.parse(element.getAttribute("data-draw-object"));

                config = ChartDrawObjectProvider.draw(config, drawConfig);
            }

            /**write url to element*/
            element.setAttribute("data-url", data["url"]);

            /**clean prior set axes*/
            config.options.scales.yAxes = [];

            /**iterate all series and gather axes*/
            let axesIndex = {x: {}, y: {}};
            var avgValue = 0;
            for (let index in data["datasets"]) {

                try {
                    let ds = data["datasets"][index];

                    /**dataseries must bring own yaxis config!*/
                    if (!ds.hasOwnProperty("yAxis")) {
                        // console.log("Missing yAxis!");
                        continue;
                    }
                    let axis = Object.assign({}, ds["yAxis"]);

                    /**having modified x-axis?*/
                    if (ds.hasOwnProperty("xAxis")) {
                        config.options.scales.xAxes = [ds["xAxis"]];
                    }

                    /**overwrite global chart type?*/
                    if (ds.hasOwnProperty("chartType")) {
                        config.type = ds["chartType"];
                    }

                    /**is there already an axis of this type?*/
                    let id = null;

                    /**already configured axis?*/
                    if (axis["id"].indexOf("y-axis-") !== -1) {
                        id = axis["id"];

                    /** no axis of this type configured yet*/
                    } else if (!axesIndex.y.hasOwnProperty(axis.id)) {
                        /**generate unique id and add to index and config*/
                        id = "y-axis-" + config.options.scales.yAxes.length;
                        axesIndex.y[axis.id] = id;
                        axis["id"] = id;
                        config.options.scales.yAxes.push(axis);
                    } else {
                        id = axesIndex.y[axis.id];
                    }

                    /**assign axis to series*/
                    data["datasets"][index].yAxisID = id;
                    data["datasets"][index].xAxisID = "x-axis-0";

                    if (element.getAttribute("data-draw-avg") && element.getAttribute("data-draw-avg") !== "") {
                        let dataAvg = 0;
                        for (let i in ds["data"]) {
                            dataAvg = dataAvg + ds['data'][i]['y'];
                        }
                        avgValue = avgValue + dataAvg / ds["data"].length;

                    }
                } catch (e) {
                    console.log(e);
                }
            }

            avgValue = avgValue / data["datasets"].length;

            if (element.getAttribute("data-draw-avg") && element.getAttribute("data-draw-avg") !== "") {
                    var drawConfig = {
                        [element.getAttribute("data-draw-avg")]:
                            {
                                "value": Units.rounded(avgValue, 2),
                                "label": {
                                    "enabled": true,
                                    "content": "Avg. " + Units.rounded(avgValue, 2)
                                }
                            }
                    };
                    config = ChartDrawObjectProvider.draw(config, drawConfig);
            }

            if(data["datasets"].length > 10 || element.getAttribute("data-legend-hide")){
                config['options']['legend']['display'] = false;
            }

            if(this.element.getAttribute("data-minYAxis") === "yes"){
                //calculate -10% of lowest data and update options
                let allYValues = [];
                data.datasets.forEach(function(e) {
                    let ys = e.data.map(d => d.y);
                    let min = Math.min(...ys);
                    allYValues.push(min);
                });
                let finalMin = Math.min(...allYValues) || 0;
                if(config.options.scales.yAxes[0] !== undefined){
                    config.options.scales.yAxes[0].ticks.min = finalMin*0.9;
                }
            }

            /**assign axes to left or right*/
            this.assignAxesPosition(config);

            /**remove loading backgound*/
            this.element.classList.remove("loading");

            /**activate download button*/
            let href = document.createAttribute ("href");
            href.value = data["url"] + "&format=csv&disposition=download";

            let download = document.createElement("a");
            download.attributes.setNamedItem(href);
            download.classList.add("ui-components-chart-download");
            download.classList.add("btn");
            download.classList.add("btn-default");
            download.classList.add("btn-xs");
            download.innerHTML="<span class='fa fa-download'></span>";
            download.style.zIndex='9999';
            this.element.appendChild(download);

            /**build chart with config*/
            /*console.log(config);*/

            Chart.pluginService.register({
                beforeUpdate: function( chartInstance ) {
                    chartInstance.data.datasets.forEach( function( dataset ) {

                        /**has method to modify points?*/
                        if (dataset.hasOwnProperty('valueModify') &&
                            typeof dataset.valueModify === "function") {

                            for(var i in dataset.data) {
                                /**get value that need to be modified*/
                                var modification = dataset.valueModify.call(this, dataset.data[i]);
                                for (var m in modification) {

                                    if (!dataset.hasOwnProperty(m)) {
                                        dataset[m] = [];
                                    }

                                    if (!Array.isArray(dataset[m])) {
                                        dataset[m] = [];
                                    }

                                    dataset[m][i] = modification[m];
                                }
                            }
                        }
                    });
                }
            });

            this.chart = this.createChart(ctx, config);
            this.chart.data.labels = data.labels;
            this.chart.data.datasets = this.sortZIndex(data.datasets,element.getAttribute("data-zindex"));
            this.chart.update();
        });
    }

    assignAxesPosition(config) {

        /**Count axes but exclude hidden axes*/
        let c = 0;
        for (var a in config.options.scales.yAxes) {
            if (config.options.scales.yAxes[a].display === false) {
                continue;
            }
            c++;
        }

        if (c === 2) {
            config.options.scales.yAxes[1].position = "right";
        } else if (c === 3) {
            config.options.scales.yAxes[1].position = "right";
            config.options.scales.yAxes[2].position = "right";
        } else if (c === 4) {
            config.options.scales.yAxes[3].position = "right";
            config.options.scales.yAxes[4].position = "right";
        }
    }

    /**
     * Sort by optional given z-index data-element channelname:zindex
     * @param datasets
     * @param zindex
     * @returns {*}
     */
    sortZIndex(datasets,zindex) {
        if (null === zindex) {
            return datasets;
        }

        let indices = zindex.split(",");
        let zIndex = {};
        for (let index of indices) {
            let zIndexValues = index.split(":");
            zIndex[zIndexValues[0]] = zIndexValues[1];
        }

        datasets.sort((a, b) => {
           return (zIndex[a.channel] || Number.MAX_VALUE) - (zIndex[b.channel] || Number.MAX_VALUE);
        });

        return datasets;
    }

    getDefaultConfig() {
        let config = Object.assign(
            {},
            ChartDefault,
            {
                data: {}
            }
        );
        config.options.tooltips.mode = this.element.getAttribute("data-tooltip-mode") || "nearest";

        if(this.element.getAttribute("data-enable-dots") === "yes"){
            config.options.elements.point.radius = 2;
            config.options.elements.point.hitRadius = 3;
            config.options.elements.point.hoverRadius = 4;
        }

        if(this.element.getAttribute("data-hover-mode")){
            config.options.hover.mode = this.element.getAttribute("data-hover-mode");
        }

        if (this.clickAction) {
            config.options.onClick = (event, sources) => {
                let element = this.chart.getElementAtEvent(event);
                if (! element.length) return;

                this.clickAction.perform(this._getActionScope(element[0]));
            };

            this.canvas.addEventListener('mousemove', (evt) => {
                let element = this.chart.getElementAtEvent(event);
                this.canvas.style.cursor = element ? "pointer" : "default";
            });

        }

        if (this.hoverAction) {
            let lastHoverElement;
            this.canvas.addEventListener('mousemove', (event) => {
                let element = this.chart.getElementAtEvent(event);
                if (! element.length) {
                    if (lastHoverElement) this.hoverAction.deactivate();
                    lastHoverElement = null;
                    return;
                }

                if (lastHoverElement === element[0]) return;
                lastHoverElement = element[0];

                this.hoverAction.perform(this._getActionScope(element[0]));
            });
        }

        return config;
    }

    _getActionScope(sender) {
        return {
            x: sender._model.x,
            y: sender._model.y,
            label: sender._chart.data.labels[sender._index],
            value: sender._chart.data.datasets[sender._datasetIndex].data[sender._index],
            datasetLabel: sender._chart.data.labels[sender._datasetIndex],
            index: sender._index,
            datasetIndex: sender._datasetIndex,

            chart: sender._chart,
            dataset: sender._chart.data.datasets[sender._datasetIndex]
        };
    }

    createChart(ctx, config) {
        return new Chart(ctx, config);
    }

    load() {
        return new Promise((resolve, reject) => {
            ChartDataProvider.load(
                this.element.getAttribute("data-provider"),
                this.element.getAttribute("data-granularity"),
                this.element.getAttribute("data-channels"),
                this.element.getAttribute("data-group"),
                this.element.getAttribute("data-index"),
                this.element.getAttribute("data-sort"),
                this.element.getAttribute("data-labels")
            ).then(
                (data) => {
                    resolve && resolve(data);
                },
                (data) => {
                    reject && reject(data);
                    //TODO: Error handling
                }
            );
        });
    }
}

Component.parse(".ui-components-chart", ChartComponent);



// WEBPACK FOOTER //
// ./src/components/chart/ChartComponent.js